import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { BaseHttpService } from './base-http.service';
import { DepartmentEstimatedProfit, DepartmentsSummary } from '../dashboard/departments-summary/departments-summary.component';
import { ConsultantContribution, ConsultantRanking } from '../dashboard/consultant-ranking/consultant-ranking.component';

@Injectable({
  providedIn: 'root'
})
export class DashboardService extends BaseHttpService {

  constructor(
    http: HttpClient
  ) {
    super(http);
  }

  public departmentsSummary(year: number, includeWeightedPipeline: boolean, departmentId: string | null) {
    const url = `${this.baseApiUrl}/dashboard/departments-summary/${year}?includeWeightedPipeline=${includeWeightedPipeline}${this.departmentParam(departmentId)}`;
    return firstValueFrom(this.http.get<DepartmentsSummary[]>(url));
  }

  public estimatedProfitAfterExpenses(year: number, includeWeightedPipeline: boolean, departmentId: string | null) {
    const url = `${this.baseApiUrl}/dashboard/estimated-profit-after-expenses/${year}?includeWeightedPipeline=${includeWeightedPipeline}${this.departmentParam(departmentId)}`;
    return firstValueFrom(this.http.get<DepartmentEstimatedProfit[]>(url));
  }

  public consultantRanking(year: number, ordering: "highest" | "lowest", count: number, includeWeightedPipeline: boolean, departmentId: string | null) {
    const url = `${this.baseApiUrl}/dashboard/consultant-ranking/${year}/${ordering}/${count}?includeWeightedPipeline=${includeWeightedPipeline}${this.departmentParam(departmentId)}`;
    return firstValueFrom(this.http.get<ConsultantRanking[]>(url));
  }

  public consultantRankingTotal(year: number, ordering: "highest" | "lowest", count: number, includeWeightedPipeline: boolean, departmentId: string | null) {
    const url = `${this.baseApiUrl}/dashboard/consultant-ranking-total/${year}/${ordering}/${count}?includeWeightedPipeline=${includeWeightedPipeline}${this.departmentParam(departmentId)}`;
    return firstValueFrom(this.http.get<ConsultantRanking[]>(url));
  }

  public consultantRankingAfterExpenses(year: number, ordering: "highest" | "lowest", count: number, includeWeightedPipeline: boolean, departmentId: string | null) {
    const url = `${this.baseApiUrl}/dashboard/consultant-ranking-after-expenses/${year}/${ordering}/${count}?includeWeightedPipeline=${includeWeightedPipeline}${this.departmentParam(departmentId)}`;
    return firstValueFrom(this.http.get<ConsultantContribution[]>(url));
  }

  private departmentParam(departmentId: string | null, asFirstParam = false): string {
    if (!departmentId) return '';
    return `${asFirstParam ? '?' : '&'}departmentId=${departmentId}`;
  }
}
